export default __webpack_public_path__ + "static/media/mainlogo.5bc2ba20.svg";